import { render, staticRenderFns } from "./A8Info.vue?vue&type=template&id=6c590d23&"
import script from "./A8Info.vue?vue&type=script&lang=ts&"
export * from "./A8Info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports